module.exports = __webpack_public_path__ + "img/map_12.400bb11d.png";